import { AppMenuItemModule } from 'src/app/shared/menu/app.menu-item.module';
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { AppSharedModule } from 'src/app/shared/shared.module';
import { AppInlineMenuComponent } from './app.inlinemenu.component';
import { AppMenuComponent } from './app.menu.component';
import { AppRightMenuComponent } from './app.rightmenu.component';
import { AppSubMenuComponent } from './app.submenu.component';

@NgModule({
    imports: [
        CommonModule,
        AppSharedModule,
        AppMenuItemModule
    ],
    declarations: [
        AppMenuComponent,
        AppSubMenuComponent,
        AppInlineMenuComponent,
        AppRightMenuComponent,
    ],
    exports: [
        AppMenuComponent,
        AppSubMenuComponent,
        AppInlineMenuComponent,
        AppRightMenuComponent,
    ]
})
export class AppMenuModule {
}

